module.exports = __webpack_public_path__ + "static/media/сушка-для-фруктів.8a6517e7.png";